import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useFileDownloader from '../../useFileDownloader';

const useExportWaitlist = () => {
    const request = useFileDownloader();
    const [loading, setLoading] = useState(false);

    const onDownloadWaitlistError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while downloading waitlist'
        );
    };

    const onDownloadWaitlistSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        toast.success("Waitlist started downloading");
    };

    const downloadWaitlist = () => {
        const url: HttpConfig = {
            url: `ba/v1/waitlist/export`,
            method: 'get',
        };

        request(url, onDownloadWaitlistSuccess, setLoading, onDownloadWaitlistError, 'Waitlist.xlsx');
    };

    return { downloadWaitlist, loading };
};

export default useExportWaitlist;

